export default {
  alert: {
    width: '100%',
  },
};
